import activity from './locales/js/activity.pl.js';
import analytics from './locales/js/analytics.pl.js';
import announcement from './locales/js/announcement.pl.js';
import building from './locales/js/building.pl.js';
import button from './locales/js/button.pl.js';
import client from './locales/js/client.pl.js';
import company from './locales/js/company.pl.js';
import constants from './locales/js/constants.pl.js';
import contact from './locales/js/contact.pl.js';
import countries from './locales/js/countries.pl.js';
import customer from './locales/js/customer.pl.js';
import decision from './locales/js/decision.pl.js';
import decision_type from './locales/js/decision_type.pl.js';
import document from './locales/js/document.pl.js';
import dropzone from './locales/js/dropzone.pl.js';
import editor_ziggu from './locales/js/editor_ziggu.pl.js';
import employee from './locales/js/employee.pl.js';
import form from './locales/js/form.pl.js';
import inspiration from './locales/js/inspiration.pl.js';
import inspiration_list from './locales/js/inspiration_list.pl.js';
import installment from './locales/js/installment.pl.js';
import installment_term from './locales/js/installment_term.pl.js';
import integration from './locales/js/integration.pl.js';
import integration_error from './locales/js/integration_error.pl.js';
import issue from './locales/js/issue.pl.js';
import issue_category from './locales/js/issue_category.pl.js';
import issue_list from './locales/js/issue_list.pl.js';
import issue_status from './locales/js/issue_status.pl.js';
import levels from './locales/js/levels.pl.js';
import lot from './locales/js/lot.pl.js';
import message from './locales/js/message.pl.js';
import milestone from './locales/js/milestone.pl.js';
import modal from './locales/js/modal.pl.js';
import navbar from './locales/js/navbar.pl.js';
import notification from './locales/js/notification.pl.js';
import pages from './locales/js/pages.pl.js';
import partner from './locales/js/partner.pl.js';
import phase from './locales/js/phase.pl.js';
import profile from './locales/js/profile.pl.js';
import project from './locales/js/project.pl.js';
import proposal from './locales/js/proposal.pl.js';
import question from './locales/js/question.pl.js';
import question_list from './locales/js/question_list.pl.js';
import reminder from './locales/js/reminder.pl.js';
import select from './locales/js/select.pl.js';
import session from './locales/js/session.pl.js';
import signature from './locales/js/signature.pl.js';
import space from './locales/js/space.pl.js';
import subscription from './locales/js/subscription.pl.js';
import survey from './locales/js/survey.pl.js';
import survey_type from './locales/js/survey_type.pl.js';
import tenant from './locales/js/tenant.pl.js';
import ticket from './locales/js/ticket.pl.js';
import timestamp from './locales/js/timestamp.pl.js';
import toast from './locales/js/toast.pl.js';
import todo from './locales/js/todo.pl.js';
import todo_list from './locales/js/todo_list.pl.js';
import unit from './locales/js/unit.pl.js';
import upsell from './locales/js/upsell.pl.js';
import validation from './locales/js/validation.pl.js';
import window from './locales/js/window.pl.js';

export default {
  pl: {
    ...activity.pl,
    ...analytics.pl,
    ...announcement.pl,
    ...building.pl,
    ...button.pl,
    ...client.pl,
    ...company.pl,
    ...constants.pl,
    ...contact.pl,
    ...countries.pl,
    ...customer.pl,
    ...decision.pl,
    ...decision_type.pl,
    ...document.pl,
    ...dropzone.pl,
    ...editor_ziggu.pl,
    ...employee.pl,
    ...form.pl,
    ...inspiration.pl,
    ...inspiration_list.pl,
    ...installment.pl,
    ...installment_term.pl,
    ...integration.pl,
    ...integration_error.pl,
    ...issue.pl,
    ...issue_category.pl,
    ...issue_list.pl,
    ...issue_status.pl,
    ...levels.pl,
    ...lot.pl,
    ...message.pl,
    ...milestone.pl,
    ...modal.pl,
    ...navbar.pl,
    ...notification.pl,
    ...pages.pl,
    ...partner.pl,
    ...phase.pl,
    ...profile.pl,
    ...project.pl,
    ...proposal.pl,
    ...question.pl,
    ...question_list.pl,
    ...reminder.pl,
    ...select.pl,
    ...session.pl,
    ...signature.pl,
    ...space.pl,
    ...subscription.pl,
    ...survey.pl,
    ...survey_type.pl,
    ...tenant.pl,
    ...ticket.pl,
    ...timestamp.pl,
    ...toast.pl,
    ...todo.pl,
    ...todo_list.pl,
    ...unit.pl,
    ...upsell.pl,
    ...validation.pl,
    ...window.pl,
  },
};
